// One of the three signs, side by side under the title: its glyph and name,
// then its constellation on a patch of the night's sky, or an empty ring
// inviting a choice. Tapping it opens the picker; once the horoscope is
// written the signs are fixed.
import type { Sign, SignConstellation } from '../../systems/api/types';
import { ConstellationArt } from '../sky/ConstellationArt';
import { SIGN_LABELS, SignGlyph } from './signs';

interface Props {
  sign: Sign;
  constellation: SignConstellation | null;
  sky: { top: string; mid: string };
  /** Fixed: the horoscope is written, or being written. */
  fixed: boolean;
  onOpen: () => void;
}

export function SignSlot({ sign, constellation, sky, fixed, onOpen }: Props) {
  const label = SIGN_LABELS[sign];
  const aria = constellation ? `${label}: ${constellation.word}${fixed ? '' : '. Choose another'}` : `${label}: choose a constellation`;
  return (
    <button type="button" className="sign-slot panel" data-filled={constellation !== null} onClick={onOpen} disabled={fixed} aria-label={aria}>
      <span className="sign-slot-head">
        <SignGlyph sign={sign} />
        <span className="label-mono">{label}</span>
      </span>
      <span className="sign-slot-art">
        {constellation ? (
          <ConstellationArt figure={constellation} width={200} height={200} padX={34} padY={34} maxScale={0.42} top={sky.top} mid={sky.mid} dust={30} />
        ) : (
          <svg viewBox="0 0 200 200" className="sign-slot-empty" aria-hidden="true">
            <circle cx="100" cy="100" r="62" />
            <path d="M100 84v32M84 100h32" />
          </svg>
        )}
      </span>
      <span className={constellation ? 'sign-slot-word mono' : 'sign-slot-word is-empty quiet'}>{constellation ? constellation.word : 'Choose'}</span>
    </button>
  );
}
